/***
 * 创建人：段锐
 * 时间：2019-06-10
 * 描述：对身份证进行验证
 * 更新记录: 
 */
import { Directive} from "@angular/core"
import { Validator, AbstractControl, NG_VALIDATORS} from "@angular/forms"

@Directive({
  selector:"[validatorIdcard]",
  providers:[{provide:NG_VALIDATORS,useExisting:ValidatorIdcardDirective,multi:true}]
})
export class ValidatorIdcardDirective implements Validator{
  constructor(){

  }
  validate(control:AbstractControl):{[property:string]:string}{
     //15位身份证号码的基本校验
      let reg15=/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      //18位身份证号码的基本格式校验
      let reg18= /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/;
      //输入框的值
      let idcard=control.value;

      //为空时不验证
      if(!idcard || idcard==""){
        return null
      }
      if(reg15.test(idcard) || reg18.test(idcard)){
         return null
      }else{
         return {ValidateIdcard:"身份证格式不匹配"}
      }
  }
}